import { apiCall } from "./Interceptor";

const AUTH = "/auth/login";
const AUTH_FIREBASE_TOKEN = "/auth/firebaseToken";
const AUTH_FIREBASE_TOKEN_LOGOUT = "/auth/logout";

const login = async (data) => {
    const response = await apiCall.post(AUTH,data);
    return response;
}
const sendFirebaseToken = async (token) => {
  const response = await apiCall.post(`${AUTH_FIREBASE_TOKEN}?firebaseToken=${token}`);
  return response;
}
const logoutFirebaseToken = async (token) => {
  const response = await apiCall.put(`${AUTH_FIREBASE_TOKEN_LOGOUT}?firebaseToken=${token}`);
  return response;
}
export default {
  login,
  sendFirebaseToken,
  logoutFirebaseToken,
};
